
// ✅ Updated SponsorCard.js (Uses LinearProgress)
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase/firebaseConfig";
import { collection, getDocs } from "firebase/firestore";

import { fetchSchoolId } from "../firebase/firestoreUtils";
import LinearProgress from "./LinearProgress";
import "../styles/ClubPage.css";

const formatCurrency = (num) => {
    if (num >= 1e12) return 'RM ' + (num / 1e12).toFixed(1) + 'T';
    if (num >= 1e9) return 'RM ' + (num / 1e9).toFixed(1) + 'B';
    if (num >= 1e6) return 'RM ' + (num / 1e6).toFixed(1) + 'M';
    if (num >= 1e3) return 'RM ' + (num / 1e3).toFixed(1) + 'K';
    return 'RM ' + num.toLocaleString();
};

const SponsorCard = ({ fundraiser, fundraiserId, schoolShortName, hideReadMore = false }) => {
    const navigate = useNavigate();
    const [raised, setRaised] = useState(0);

    useEffect(() => {
        const fetchRaisedAmount = async () => {
            try {
                const schoolId = await fetchSchoolId(schoolShortName);
                if (!schoolId) return;

                const donorRef = collection(db, `schools/${schoolId}/fundraisers/${fundraiserId}/donors`);
                const snapshot = await getDocs(donorRef);
                let total = 0;

                snapshot.forEach(doc => {
                    const data = doc.data();
                    if (data.confirmed === "confirmed") {
                        total += Number(data.amount || 0);
                    }
                });

                setRaised(total);
            } catch (err) {
                console.error("Error fetching donor data:", err);
            }
        };


        if (schoolShortName && fundraiserId) fetchRaisedAmount();
    }, [schoolShortName, fundraiserId]);

    if (!fundraiser || !fundraiserId || !schoolShortName) return null;

    const donationData = fundraiser?.donations?.[0] || {};
    const goal = parseFloat(donationData.goal_amount) || 0;
    const title = donationData.title || "Untitled";
    const image = donationData.image || null;
    const toGo = goal - raised;
    const percentage = goal > 0 ? (raised / goal) * 100 : 0;

    const handleDonateClick = () => {
        navigate(`/${schoolShortName}/fundraiser/${fundraiserId}`);
    };

    return (
        <div className="sponsor-card">
            <span className="sponsor-badge">FUNDRAISER</span>

            {image && <img src={image} alt="Fundraiser" className="sponsor-image" />}
            <h3 className="sponsor-title">{title}</h3>

            <LinearProgress percentage={percentage} />

            <div className="sponsor-info">
                <p><strong>Goal:</strong> {formatCurrency(goal)}</p>
                <p><strong>Raised:</strong> {formatCurrency(raised)}</p>
                <p><strong>To Go:</strong> {formatCurrency(toGo)}</p>
            </div>
            {!hideReadMore && (

                <button onClick={handleDonateClick}>Read More</button>
            )}
        </div>
    );
};

export default SponsorCard;